__turbopack_context__.v({
  "container": "PressReleaseExample-module-scss-module__zBOMyG__container",
  "content": "PressReleaseExample-module-scss-module__zBOMyG__content",
  "ctaButton": "PressReleaseExample-module-scss-module__zBOMyG__ctaButton",
  "darkColors": "PressReleaseExample-module-scss-module__zBOMyG__darkColors",
  "description": "PressReleaseExample-module-scss-module__zBOMyG__description",
  "example": "PressReleaseExample-module-scss-module__zBOMyG__example",
  "headline": "PressReleaseExample-module-scss-module__zBOMyG__headline",
  "image": "PressReleaseExample-module-scss-module__zBOMyG__image",
  "info": "PressReleaseExample-module-scss-module__zBOMyG__info",
  "logo": "PressReleaseExample-module-scss-module__zBOMyG__logo",
  "modal": "PressReleaseExample-module-scss-module__zBOMyG__modal",
  "section": "PressReleaseExample-module-scss-module__zBOMyG__section",
  "share": "PressReleaseExample-module-scss-module__zBOMyG__share",
  "shareIcon": "PressReleaseExample-module-scss-module__zBOMyG__shareIcon",
  "shareTitle": "PressReleaseExample-module-scss-module__zBOMyG__shareTitle",
  "summary": "PressReleaseExample-module-scss-module__zBOMyG__summary",
  "tag": "PressReleaseExample-module-scss-module__zBOMyG__tag",
  "tagTitle": "PressReleaseExample-module-scss-module__zBOMyG__tagTitle",
  "tags": "PressReleaseExample-module-scss-module__zBOMyG__tags",
  "tagsList": "PressReleaseExample-module-scss-module__zBOMyG__tagsList",
  "tipContainer": "PressReleaseExample-module-scss-module__zBOMyG__tipContainer",
  "wrapper": "PressReleaseExample-module-scss-module__zBOMyG__wrapper",
});
